import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from '@material-ui/core'
import React from 'react'
import { COLORS } from '../../constants'

export interface NoticeDialogProps extends Omit<DialogProps, 'open'> {
  attachState: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
  title?: string
  renderBeforeOpen?: boolean
  confirmBtnText?: string
  closeOnConfirm?: boolean
  onConfirm?: () => void
}

export default function NoticeDialog({
  attachState,
  title,
  renderBeforeOpen = false,
  confirmBtnText = 'okay',
  closeOnConfirm = true,
  onConfirm,
  children,
  ...dialogProps
}: NoticeDialogProps) {
  const [open, setOpen] = attachState

  const handleConfirm = () => {
    if (closeOnConfirm) {
      setOpen(false)
    }
    onConfirm?.()
  }

  if (renderBeforeOpen && !open) {
    return null
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} {...dialogProps}>
      {title && <DialogTitle>{title}</DialogTitle>}

      <DialogContent>{children}</DialogContent>

      <DialogActions>
        <Button onClick={handleConfirm} style={{ color: COLORS.dangerRed }}>
          {confirmBtnText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
